var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('LinkdeConviteEventNew',{attrs:{"shareInfo":_vm.shareInfo}}):_c('LinkdeConviteEvent')
}
var staticRenderFns = []

export { render, staticRenderFns }